import { BehaviorSubject, EMPTY, from, merge, Observable, of, Subject } from 'rxjs';
import { distinctUntilChanged, filter, mergeMap, switchMap, timeout } from 'rxjs/operators';

export let notificationsEnabled$ = new BehaviorSubject(false);
let notifyMessages$ = new Subject();

export function notifyAbout(msg) {
    notifyMessages$.next(msg);
}

let requestNotificationPermission = mergeMap(msg => {
    let perm = Notification?.permission;
    if (perm === 'granted') {
        return of(msg);
    }
    if (perm === 'denied') {
        return EMPTY;
    }
    if (perm === 'default') {
        return from(Notification.requestPermission()).pipe(
            switchMap(status => {
                if (status !== 'granted') {
                    return EMPTY;
                }
                return of(msg);
            }),
        );
    }
    console.log(`Notifications disabled because of unknown support. Permission: ${perm}`);
    return EMPTY;
}, 1);

let notificationPermissionRequest$ = notificationsEnabled$.pipe(
    filter(enabled => enabled),
    requestNotificationPermission,
);

let notificationPopup$ = notificationsEnabled$.pipe(
    distinctUntilChanged(),
    switchMap(enabled => enabled ? notifyMessages$ : EMPTY),
    requestNotificationPermission,
    mergeMap(msg => new Observable(observer => {
        if (document.hasFocus()) {
            observer.complete();
            return undefined;
        }
        let n = new Notification(msg);
        n.addEventListener('close', () => observer.complete(), false);
        observer.next(n);
        return () => n.close();
    }).pipe(
        timeout({
            each: 5*1000,
            with: () => EMPTY,
        }),
    ), 3),
);

export let notifications$ = merge(
    notificationPermissionRequest$,
    notificationPopup$,
);
